// What a wizard page IS, in the one place both the autosaved snapshot and the
// committed batch payload read it from.
//
// The two representations have to stay in lockstep: a page the snapshot persists
// but the commit drops means a resumed draft is not the draft that commits. These
// rules were written twice before this module existed, with the second copy's
// comment saying "the same rule buildSubmissionBatchPayload applies at commit" —
// an invariant asserted in prose rather than in code.
import { htmlToPlainText } from './html';

export const isManual = (page) => page?.source === 'manual';

/** 0-based position INSIDE the page's own file — 0 for images and single pages. */
export const pageIndexOf = (page) => Number(page?.sourcePageIndex) || 0;

/** The typed text of a manual page, or '' if it has none worth keeping. */
export const manualTextOf = (page) => htmlToPlainText(page?.content);

/**
 * The name the page's file was uploaded under.
 *
 * Three sources because a page reaches this from three directions: freshly
 * uploaded (a File instance), restored from a snapshot (`fileName`), or restored
 * from submissions (neither — only the url, which carries the extension). Reading
 * just one of them is how a docx ends up classified as a PDF.
 */
export const fileNameOf = (page) =>
  page?.fileName || page?.file?.name || page?.fileUrl || '';

/**
 * Can this page be expressed at all? A file page whose upload never returned a
 * url has nothing to reference, and an empty typed page has nothing to store.
 */
export const isExpressible = (page) =>
  isManual(page) ? Boolean(manualTextOf(page)) : Boolean(page?.fileUrl);
